export const API_PREFIX = '/myapi';
export const API_HOST = globalThis.location.origin;
export const X_CSRF_TOKEN = 'x-csrf-token';
export const X_CSRF_COOKIE = 'csrftoken';

export const pathLogin = '/login';
export const pathsApi = {
    uploadFile: '/file/upload',
};
export const pathRoot = '/logistics';
